"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialSignins = void 0;
const carabiners_1 = require("@clearsummit/carabiners");
const google_1 = require("@react-oauth/google");
const react_1 = __importDefault(require("react"));
const react_apple_login_1 = __importDefault(require("react-apple-login"));
const react_redux_1 = require("react-redux");
const components_1 = require("@/components");
const config_1 = __importDefault(require("@/config"));
const redux_1 = require("@/redux");
const api_payloads_1 = require("@/redux/api-payloads");
const styles_scss_1 = __importDefault(require("./styles.scss"));
const SocialSignins = ({ buttons, loginWithGoogle, loginWithApple }) => {
    const login = (0, google_1.useGoogleLogin)({
        onSuccess: codeResponse => loginWithGoogle(codeResponse.access_token),
        flow: "implicit",
    });
    const appleResponse = (data) => {
        var _a;
        const { code, id_token } = (_a = data === null || data === void 0 ? void 0 : data.authorization) !== null && _a !== void 0 ? _a : {};
        if (code && id_token) {
            loginWithApple(code, id_token);
        }
    };
    return react_1.default.createElement("div", { className: styles_scss_1.default.buttonContainer },
        buttons.google && react_1.default.createElement(components_1.Button, { onClick: login, className: (0, carabiners_1.joinStr)(styles_scss_1.default.googleBtn, styles_scss_1.default.btn) }, "Login with Google"),
        buttons.apple &&
            react_1.default.createElement(react_apple_login_1.default, { callback: appleResponse, scope: "name email", clientId: config_1.default.appleClientId, redirectURI: config_1.default.appleRedirectUrl, usePopup: true, render: ({ onClick }) => react_1.default.createElement(components_1.Button, { onClick: onClick, className: (0, carabiners_1.joinStr)(styles_scss_1.default.appleBtn, styles_scss_1.default.btn) }, "Login with Apple") }));
};
exports.SocialSignins = SocialSignins;
const mapDispatchToProps = {
    loginWithGoogle: (accessToken) => redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.authenticateGooglePayload)(accessToken)),
    loginWithApple: (access_token, id_token) => redux_1.ActionCreators.api.makeRequest.dispatch((0, api_payloads_1.authenticateApplePayload)({ access_token, id_token }))
};
exports.SocialSignins.defaultProps = {
    buttons: {
        google: true,
        facebook: true,
        apple: true
    },
};
exports.default = (0, react_redux_1.connect)(null, mapDispatchToProps)(exports.SocialSignins);
